// @flow
export type SignUpPhoneNumberActionType =
  | {|
      type: 'SIGNUP_SET_PICKED_PHONE_NUMBER',
      payload: {|
        ouid: string,
        number: string,
      |},
    |}
  | {|
      type: 'SIGNUP_SET_KEPT_PHONE_NUMBER',
      payload: {|
        number: string,
        rio?: string,
      |},
    |}
  | {|
      type: 'SIGNUP_CONFIRM_KEPT_PHONE_NUMBER',
      payload: {|
        numberConfig: {
          phoneNumber: string,
          rioNumber: string,
        },
        isActivationPath: ?boolean,
      |},
    |}
  | {|
      type: 'SIGNUP_CLEAR_CHOSEN_PHONE_NUMBER',
    |};

export function setPickedPhoneNumber(ouid: string, number: string = ''): SignUpPhoneNumberActionType {
  return {
    type: 'SIGNUP_SET_PICKED_PHONE_NUMBER',
    payload: {
      ouid,
      number,
    },
  };
}
export function setKeptPhoneNumber(number: string, rio?: string): SignUpPhoneNumberActionType {
  return {
    type: 'SIGNUP_SET_KEPT_PHONE_NUMBER',
    payload: {
      number,
      rio,
    },
  };
}

export const confirmKeptPhoneNumber = (
  numberConfig: Object,
  isActivationPath?: boolean
): SignUpPhoneNumberActionType => ({
  type: 'SIGNUP_CONFIRM_KEPT_PHONE_NUMBER',
  payload: {
    numberConfig,
    isActivationPath,
  },
});

export function clearChosenPhoneNumber(): SignUpPhoneNumberActionType {
  return {
    type: 'SIGNUP_CLEAR_CHOSEN_PHONE_NUMBER',
  };
}
